export const ANSWER_CREATE_REQUEST = "ANSWER_CREATE_REQUEST";
export const ANSWER_CREATE_SUCCSESS = "ANSWER_CREATE_SUCCSESS";
export const ANSWER_CREATE_FAIL = "ANSWER_CREATE_FAIL";
export const ANSWER_CREATE_REST = "ANSWER_CREATE_REST";

// export const ANSWER_DETAILS_REQUEST = "ANSWER_DETAILS_REQUEST";
// export const ANSWER_DETAILS_SUCCSESS = "ANSWER_DETAILS_SUCCSESS";
// export const ANSWER_DETAILS_FAIL = "ANSWER_DETAILS_FAIL";

export const ANSWER_LIST_REQUEST = "ANSWER_LIST_REQUEST";
export const ANSWER_LIST_SUCCSESS = "ANSWER_LIST_SUCCSESS";
export const ANSWER_LIST_FAIL = "ANSWER_LIST_FAIL";

export const ANSWER_LIST_DELETE_REQUEST = "ANSWER_LIST_DELETE_REQUEST";
export const ANSWER_LIST_DELETE_SUCCSESS = "ANSWER_LIST_DELETE_SUCCSESS";
export const ANSWER_LIST_DELETE_FAIL = "ANSWER_LIST_DELETE_FAIL";

export const ANSWER_MY_LIST_REQUEST = "ANSWER_MY_LIST_REQUEST";
export const ANSWER_MY_LIST_SUCCSESS = "ANSWER_MY_LIST_SUCCSESS";
export const ANSWER_MY_LIST_FAIL = "ANSWER_MY_LIST_FAIL";


export const ANSWER_ONE_REQUEST = "ANSWER_ONE_REQUEST";
export const ANSWER_ONE_SUCCSESS = "ANSWER_ONE_SUCCSESS";
export const ANSWER_ONE_FAIL = "ANSWER_ONE_FAIL";



export const ANSWER_UPDATE_STATUS_REQUEST = "ANSWER_UPDATE_STATUS_REQUEST";
export const ANSWER_UPDATE_STATUS_SUCCSESS = "ANSWER_UPDATE_STATUS_SUCCSESS";
export const ANSWER_UPDATE_STATUS_FAIL = "ANSWER_UPDATE_STATUS_FAIL";
export const ANSWER_UPDATE_STATUS_REST = "ANSWER_UPDATE_STATUS_REST";


